// The club emblem (public/logo.svg) for canvas art: icons, the social
// preview and the share card. Its blue needs a light ground, so it always
// sits on a washi-paper disc, which also gives the tightly cropped SVG the
// padding it lacks.

export const LOGO_URL = '/logo.svg';

/** The emblem's viewBox: 42.4 × 48, portrait. */
const ASPECT = 42.4 / 48;

/** Emblem height as a share of the disc's diameter: its corners just clear the rim. */
export const LOGO_IN_DISC = 0.66;

const PAPER = '#f6ead2';

let loading: Promise<HTMLImageElement> | null = null;

export function loadLogo(): Promise<HTMLImageElement> {
  loading ??= new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => {
      loading = null;
      reject(new Error('Logo failed to load'));
    };
    img.src = LOGO_URL;
  });
  return loading;
}

/** The emblem, `height` tall, centred on (cx, cy). */
export function drawLogo(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  cx: number,
  cy: number,
  height: number,
): void {
  const width = height * ASPECT;
  ctx.drawImage(img, cx - width / 2, cy - height / 2, width, height);
}

/** The emblem on a paper disc of diameter `d`, with a soft drop shadow. */
export function drawLogoBadge(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  cx: number,
  cy: number,
  d: number,
): void {
  ctx.save();
  ctx.shadowColor = 'rgba(0,0,0,0.35)';
  ctx.shadowBlur = d * 0.08;
  ctx.shadowOffsetY = d * 0.02;
  ctx.fillStyle = PAPER;
  ctx.beginPath();
  ctx.arc(cx, cy, d / 2, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
  drawLogo(ctx, img, cx, cy, d * LOGO_IN_DISC);
}

export { PAPER as LOGO_PAPER };
